import { createMachine, sendParent } from 'xstate';
import { PENDING_MACHINE_STATES_NAMES } from '../../const/machines';
export default createMachine({
    predictableActionArguments: true,
    id: 'pendingMachine',
    initial: PENDING_MACHINE_STATES_NAMES.PENDING,
    schema: {
        events: {}
    },
    context: {},
    states: {
        pending: {
            entry: [sendParent({ type: 'HOE_UPDATE_BANNER_VISIBILITY' })]
        }
    }
});
